import {ready} from '~/core/indexConf'

ready('printAgenda', '[data-print-path][data-print-formId]', printLink => {
		let iframe;
		let printPath = null;
		let form = null
		let data = null;
		// Convert to a query string
		let queryString = null;
		
		const createSelfPrintingIframe = () => {
			iframe = document.createElement("iframe");
			iframe.classList.add("hidden-print-iframe");
			iframe.setAttribute("src", printPath);
			document.body.insertAdjacentElement("beforeend", iframe);
			iframe.onload = () => iframe.contentWindow.print();
			iframe.contentWindow.onafterprint = () => iframe.remove();
		}

		printLink.addEventListener("click", e => {
		console.log('printLink click---');
			e.preventDefault();
			printPath = !!printLink.getAttribute("data-print-path") ? printLink.getAttribute("data-print-path") : null;
			if(printPath)
			{
				form = document.querySelector(`#${printLink.getAttribute("data-print-formId")}`);
				data = new FormData(form);
				queryString = new URLSearchParams(data).toString();
				printPath += `?${queryString}`;
				console.log('printPath---', printPath);
				if (printPath) createSelfPrintingIframe();
				else window.print();
			}	
			else
			{
				console.log("data-print-path is null")
			}	
	});
	
})